import LegalPage from '@/components/marketing/LegalPage';

export default function PrivacyPage() {
  return (
    <LegalPage title="Privacy Policy" lastUpdated="February 2026" testId="privacy-page">
      <p className="text-base text-slate-200">
        This Privacy Policy explains how PROP VEIW collects, uses, and protects personal
        information when you visit our website and use the PROP VEIW Service.
      </p>

      <h2>1. Information We Collect</h2>
      <h3>Information you provide</h3>
      <ul>
        <li><strong>Account information:</strong> name, email, password (hashed), role, organization name.</li>
        <li><strong>Property &amp; booking data:</strong> property addresses, booking dates, guest names, expense receipts, and any other operational data you enter.</li>
        <li><strong>Payment information:</strong> handled by our payment processor; we store only the last four digits, expiry, and brand of your card.</li>
        <li><strong>Support requests:</strong> messages you send us via email, chat, or in-app forms.</li>
      </ul>

      <h3>Information collected automatically</h3>
      <ul>
        <li>Device and browser data (user-agent, IP address, screen size).</li>
        <li>Service usage analytics (pages visited, features used, error events).</li>
        <li>Cookies and similar technologies — see our <a href="/cookies">Cookie Notice</a>.</li>
      </ul>

      <h2>2. How We Use Information</h2>
      <ul>
        <li>To provide and maintain the Service, including authenticating you and isolating your organization's data.</li>
        <li>To process billing and subscription management.</li>
        <li>To send transactional emails (booking confirmations, password resets, staff invites, security alerts).</li>
        <li>To improve product reliability, performance, and security.</li>
        <li>To send occasional product updates (you may opt out at any time).</li>
        <li>To comply with legal obligations.</li>
      </ul>

      <h2>3. Legal Bases (EEA / UK Users)</h2>
      <p>
        We process your personal data based on (a) the contract we have with you (to deliver the
        Service), (b) our legitimate interests (operating, improving, and securing the Service),
        (c) your consent (for optional marketing communications and non-essential cookies), and
        (d) compliance with legal obligations.
      </p>

      <h2>4. Sharing &amp; Disclosure</h2>
      <p>We do not sell personal information. We share data only with:</p>
      <ul>
        <li><strong>Sub-processors:</strong> infrastructure (cloud hosting, database), email delivery (Resend), and payment processing. Each sub-processor is bound by data-protection terms.</li>
        <li><strong>Staff you invite:</strong> users you add to your organization have access to operational records you grant them.</li>
        <li><strong>Legal requests:</strong> when required by a valid subpoena, court order, or applicable law.</li>
        <li><strong>Business transfers:</strong> in the event of a merger, acquisition, or asset sale we will notify affected users.</li>
      </ul>

      <h2>5. Data Retention</h2>
      <p>
        We retain Customer Data for the duration of your subscription and for thirty (30) days
        after termination to allow data export. Billing records are retained for the period
        required by tax and accounting law (typically seven years).
      </p>

      <h2>6. Your Rights</h2>
      <p>Depending on where you live, you may have the right to:</p>
      <ul>
        <li>Access, correct, or delete your personal information.</li>
        <li>Export a machine-readable copy of your data.</li>
        <li>Object to or restrict certain processing activities.</li>
        <li>Withdraw consent for marketing communications.</li>
        <li>Lodge a complaint with your local data-protection authority.</li>
      </ul>
      <p>
        To exercise these rights, email{' '}
        <a href="mailto:privacy@propveiw.com">privacy@propveiw.com</a>. We respond within thirty
        (30) days.
      </p>

      <h2>7. Security</h2>
      <p>
        We implement administrative, technical, and physical safeguards designed to protect your
        information. These include encrypted transport (TLS), encryption at rest, scoped database
        access controls, regular security reviews, and role-based access for our team. No system
        is perfectly secure; please use a strong password and enable any future MFA options.
      </p>

      <h2>8. International Transfers</h2>
      <p>
        Our servers are located in the United States. By using the Service from outside the U.S.
        you consent to the transfer of your information to the U.S. Where required, we rely on
        Standard Contractual Clauses to safeguard transfers.
      </p>

      <h2>9. Children's Privacy</h2>
      <p>
        The Service is not directed to children under 16, and we do not knowingly collect
        information from children. If you believe a child has provided us personal information,
        contact us and we will delete it.
      </p>

      <h2>10. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Material changes will be communicated
        by email or in-app notice at least fourteen (14) days before they take effect.
      </p>

      <h2>11. Contact</h2>
      <p>
        Questions or requests? Email{' '}
        <a href="mailto:privacy@propveiw.com">privacy@propveiw.com</a>. For security disclosures,
        write to <a href="mailto:security@propveiw.com">security@propveiw.com</a>.
      </p>
    </LegalPage>
  );
}
